import { render } from "./HeroBackgroundEmobil.vue?vue&type=template&id=65f3edb4&ts=true"
import script from "./HeroBackgroundEmobil.vue?vue&type=script&lang=ts"
export * from "./HeroBackgroundEmobil.vue?vue&type=script&lang=ts"

import "./HeroBackgroundEmobil.vue?vue&type=style&index=0&id=65f3edb4&lang=scss"

import exportComponent from "C:\\Arbeit\\wordpress_projekte\\castroper-klimahelden\\wp-content\\themes\\cas-klimahelden-theme\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__